class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterToggleButton = this.querySelector('.js-collection-filter-button');
    this.facetsWrapper = this.querySelector('#FacetsWrapperDesktop');

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onFilterCloseClick = this.onFilterCloseClick.bind(this); // close details
    this.onSortButtonClick = this.onSortButtonClick.bind(this); // sort button click
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    if (this.facetsWrapper) {
      this.facetsWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    if (this.filterToggleButton) {
      this.filterToggleButton.addEventListener('click', this.toggleFilterContainer.bind(this));
    }
    
    // Add event delegation for sort buttons
    this.addEventListener('click', this.onSortButtonClick);

    // Add event delegation for close buttons within js-filter details
    console.log('Adding click event listener to FacetFiltersForm');
    this.addEventListener('click', this.onFilterCloseClick);

    // Initialize sort button states
    this.initializeSortButtonStates();
  }

  toggleFilterContainer(event) {
    event.preventDefault();
    this.facetsWrapper.classList.toggle('filter-show');
  }

  // Add this new method to the FacetFiltersForm class
  onFilterCloseClick(event) {
    console.log(event.target, 'donny')
    // Check if the clicked element is a close button within a js-filter details
    if (event.target.matches('.js-filter .facets__display .close-button') ||
      event.target.closest('.js-filter .facets__display .close-button')) {

      event.preventDefault();
      event.stopPropagation();

      const closeButton = event.target.matches('.close-button') ?
        event.target : event.target.closest('.close-button');
      const jsFilterElement = closeButton.closest('.js-filter');

      if (jsFilterElement && jsFilterElement.tagName === 'DETAILS') {
        // Remove only the 'open' attribute from the details element
        jsFilterElement.removeAttribute('open');

        console.log('Removed open attribute from js-filter details element');
      }
    }
  }

  // Add new method to handle sort button clicks
  onSortButtonClick(event) {
    if (event.target.matches('.sort-button')) {
      event.preventDefault();
      event.stopPropagation();

      const sortButton = event.target;
      const sortValue = sortButton.getAttribute('data-value');
      const hiddenInput = this.querySelector('#SortBy');

      console.log('Sort button clicked:', sortValue);

      if (hiddenInput && sortValue) {
        // Update the hidden input value
        hiddenInput.value = sortValue;

        // Update button states
        this.updateSortButtonStates(sortButton);

        // Create search parameters that only include one sort_by
        const searchParams = this.createSortSearchParams(sortValue);
        console.log('Triggering sort with params:', searchParams);
        this.onSubmitForm(searchParams, event);
      } else {
        console.error('Missing hidden input or sort value:', { hiddenInput: !!hiddenInput, sortValue });
      }
    }
  }

  // Add method to update sort button states
  updateSortButtonStates(selectedButton) {
    // Remove selected state from all buttons
    this.querySelectorAll('.sort-button').forEach(button => {
      button.classList.remove('sort-button--selected');
      button.removeAttribute('aria-current');
    });

    // Add selected state to clicked button
    selectedButton.classList.add('sort-button--selected');
    selectedButton.setAttribute('aria-current', 'true');
  }

  // Add method to initialize sort button states
  initializeSortButtonStates() {
    const hiddenInput = this.querySelector('#SortBy');
    if (hiddenInput) {
      const currentValue = hiddenInput.value;
      const currentButton = this.querySelector(`.sort-button[data-value="${currentValue}"]`);
      if (currentButton) {
        this.updateSortButtonStates(currentButton);
      }
    }
  }

  // Add method to create search parameters for sorting without duplicates
  createSortSearchParams(sortValue) {
    // Get current URL parameters to avoid duplicates from multiple forms
    const currentParams = new URLSearchParams(window.location.search);
    const searchParams = new URLSearchParams();
    
    console.log('Creating sort search params for value:', sortValue);
    console.log('Current URL params:', window.location.search);
    
    // Copy all current parameters except sort_by
    for (let [key, value] of currentParams.entries()) {
      if (key !== 'sort_by') {
        console.log('Adding current parameter:', key, '=', value);
        searchParams.append(key, value);
      }
    }
    
    // Add the new sort value
    searchParams.append('sort_by', sortValue);
    
    const result = searchParams.toString();
    console.log('Final search params:', result);
    
    return result;
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // Handle sort buttons specifically
    const sortButtonsContainer = html.querySelector('.sort-buttons');
    if (sortButtonsContainer) {
      const currentSortButtonsContainer = document.querySelector('.sort-buttons');
      if (currentSortButtonsContainer) {
        currentSortButtonsContainer.innerHTML = sortButtonsContainer.innerHTML;
        
        // Re-initialize sort button states after re-render
        const facetFiltersForm = document.querySelector('facet-filters-form');
        if (facetFiltersForm && facetFiltersForm.initializeSortButtonStates) {
          facetFiltersForm.initializeSortButtonStates();
        }
      }
    }

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
